import React, { PureComponent } from 'react';
import MultiSelectReact from 'react-multi-select-ext';
import LoadingSpinner from '../component/LoadingSpinner';

  
const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000' 
};


export default class EnrolledStudentsDropDown extends PureComponent {

    constructor(props) {
        super(props);
      }

    onSectionChange = (argSelectedSectionIDs) => {   
        this.props.onChange(argSelectedSectionIDs);
    };

    render(){

        if(this.props.studentListArray.length > 0){
            return <MultiSelectReact
                options={this.props.studentListArray}
                optionClicked={this.onSectionChange.bind(this)}
                selectedBadgeClicked={this.onSectionChange.bind(this)}
                selectedOptionsStyles={selectedOptionsStyles}
                optionsListStyles={optionsListStyles}
                enableSelectAllNone={true}
            />
        }else{
            return <p>No Enrolled Students Found</p>;
        }
    }
}